export default __webpack_public_path__ + "static/media/unionpay.5367830a.svg";